import { packagePickerErrorSrc17Evid2236, platformizedPackagePickerNoSitesModalClickSrc17Evid2252, platformizedPackagePickerNoSitesModalCloseSrc17Evid2253, platformizedPackagePickerNoSitesModalLoadSrc17Evid2251, platformizedPackagePickerNotificationClickSrc17Evid2255, platformizedPackagePickerNotificationCloseSrc17Evid2256, platformizedPackagePickerNotificationShowSrc17Evid2254 } from '@wix/bi-logger-premium-data/v2';
import { getSearchParams } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../../components';
import { useBiLogger } from './useBiLogger';
import { useCommonBiEventsFields } from './useCommonBiEventsFields';
export const useInitGeneralBiEvents = () => {
  const [didInit, setDidInit] = React.useState(false);
  const module = useCurrentModule();
  const {
    setBiEvent
  } = module.SDK;
  const {
    biLogger
  } = useBiLogger();
  const {
    commonBiEventsFields,
    isLoading: isCommonBiEventsFieldsLoading
  } = useCommonBiEventsFields();
  const isLoading = isCommonBiEventsFieldsLoading;
  React.useEffect(() => {
    if (isLoading) {
      return;
    }
    setBiEvent('onNoSitesModalShow', () => {
      biLogger == null || biLogger.report(
      // 17:2251
      platformizedPackagePickerNoSitesModalLoadSrc17Evid2251({
        ...commonBiEventsFields
      }));
    });
    setBiEvent('onNoSitesModalClose', () => {
      biLogger == null || biLogger.report(
      // 17:2253
      platformizedPackagePickerNoSitesModalCloseSrc17Evid2253({
        ...commonBiEventsFields
      }));
    });
    setBiEvent('onNoSitesModalClick', _ref => {
      let {
        url
      } = _ref;
      const additionalFields = {
        url
      };
      biLogger == null || biLogger.report(
      // 17:2252
      platformizedPackagePickerNoSitesModalClickSrc17Evid2252({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onError', _ref2 => {
      let {
        errorType,
        errorMessage,
        requestId
      } = _ref2;
      const {
        debug
      } = getSearchParams();
      const additionalFields = {
        errorType,
        errorMessage,
        requestId,
        isDebug: debug
      };
      biLogger == null || biLogger.report(
      // 17:2236
      packagePickerErrorSrc17Evid2236({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onNotificationShow', _ref3 => {
      let {
        messageKey,
        step = 'unknown_step'
      } = _ref3;
      const message = `${step}: ${messageKey}`;
      const additionalFields = {
        message
      };
      biLogger == null || biLogger.report(
      // 17:2254
      platformizedPackagePickerNotificationShowSrc17Evid2254({
        ...commonBiEventsFields,
        ...additionalFields
      }));
      const {
        debug
      } = getSearchParams();
      const errorAdditionalFields = {
        errorType: 'Notification',
        errorMessage: message,
        isDebug: debug
      };
      biLogger == null || biLogger.report(
      // 17:2236
      packagePickerErrorSrc17Evid2236({
        ...commonBiEventsFields,
        ...errorAdditionalFields
      }));
    });
    setBiEvent('onNotificationClose', () => {
      biLogger == null || biLogger.report(
      // 17:2256
      platformizedPackagePickerNotificationCloseSrc17Evid2256({
        ...commonBiEventsFields
      }));
    });
    setBiEvent('onNotificationClick', _ref4 => {
      let {
        action
      } = _ref4;
      biLogger == null || biLogger.report(
      // 17:2255
      platformizedPackagePickerNotificationClickSrc17Evid2255({
        ...commonBiEventsFields,
        action
      }));
    });
    setDidInit(true);
  }, [setBiEvent, biLogger, isLoading]);
  return {
    didInit
  };
};
//# sourceMappingURL=useInitGeneralBiEvents.js.map